<template>
  <div class="text-3xl text-center font-bold text-sky-900 m-4">
    Account Login
  </div>
  <form @submit.prevent="onSubmit($event)" class="text-sm px-4">
    <div class="text-xs hidden errortext">Invalid email</div>
    <input
      @focus="clearFieldError($event)"
      type="text"
      inputmode="email"
      autocomplete="email"
      placeholder="Email"
      ref="email"
    />
    <div class="text-xs hidden errortext">Invalid password</div>
    <div class="password-wrapper">
      <input
        @focus="clearFieldError($event)"
        :type="showPassword ? 'text' : 'password'"
        placeholder="Password"
        ref="password"
      />
      <button
        type="button"
        class="toggle-password"
        @click="showPassword = !showPassword"
        aria-label="Toggle password visibility"
        tabindex="-1"
      >
        <span class="material-symbols-outlined" aria-hidden="true">
          {{ showPassword ? 'visibility_off' : 'visibility' }}
        </span>
      </button>
    </div>
    <div v-if="loginError" class="login-alert" role="alert" aria-live="polite">
      <span class="material-symbols-outlined" aria-hidden="true">
        {{ isRateLimited ? 'hourglass_top' : 'error' }}
      </span>
      <span>{{ loginError }}</span>
    </div>

    <div class="w-full flex justify-center text-lg mt-3 flex-col items-center">
      <button ref="submitterbutton" type="submit" class="relative">
        <button-inner>Login</button-inner>
      </button>
      <div class="fadeoutbutton">Success!</div>
    </div>
  </form>
  <div class="flex justify-center pb-1">
    <span
      @click="showForgot"
      class="text-sm leading-6 mr-1 mb-1 cursor-pointer underline"
      >Forgot Password</span
    >
  </div>
  <div class="flex justify-center pb-1">
    <span
      @click="swapShowForm"
      class="cursor-pointer text-sm leading-6 mr-1 mb-3 underline text-green-800"
      >Don't have an account? Signup Now</span
    >
  </div>
</template>
<script>
import { ref, inject } from "vue";
import store from "../../store/index.js";
export default {
  props: ["showForgot"],
  setup() {
    function validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    const email = ref(null);
    const password = ref(null);
    const submitterbutton = ref(null);
    const showPassword = ref(false);
    const loginError = ref("");
    const isRateLimited = ref(false);

    const swapShowForm = inject("swapShowForm");

    const removeBadBorder = inject("removeBadBorder");

    function clearFieldError(event) {
      loginError.value = "";
      isRateLimited.value = false;
      removeBadBorder(event);
    }

    async function parseResponse(resp) {
      const contentType = resp.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        return resp.json().catch(() => ({}));
      }
      const message = await resp.text().catch(() => "");
      return { message };
    }

    function loginErrorMessage(err) {
      if (err.status === 429) {
        return err.message || "Too many login attempts. Please try again in an hour.";
      }
      return err.message || "Login failed. Check your email and password.";
    }

    function onSubmit() {
      loginError.value = "";
      isRateLimited.value = false;

      let validEntries = true;
      if (!email.value.value || !validateEmail(email.value.value)) {
        email.value.classList.add("bad-border");
        email.value.previousElementSibling.classList.remove("hidden");
        email.value.value = "";
        validEntries = false;
      }
      if (!password.value.value || password.value.value.length < 8) {
        password.value.classList.add("bad-border");
        password.value.previousElementSibling.classList.remove("hidden");
        password.value.value = "";
        validEntries = false;
      }

      if (!validEntries) return;

      const button = submitterbutton.value;

      button.disabled = true;

      button.children[1].style.display = "none";
      button.children[0].style.display = "flex";

      let data = {
        email: email.value.value,
        password: password.value.value,
      };

      const url = store.state.hostname + "/api/v1/users/login";
      const request = new Request(url, {
        credentials: "include",
        method: "POST",
        body: JSON.stringify(data),

        headers: { "content-type": "application/json" },
      });
      fetch(request)
        .then(async (resp) => {
          const data = await parseResponse(resp);
          if (!resp.ok || data.status == "fail") {
            const error = new Error(data.message || "Login failed");
            error.status = resp.status;
            throw error;
          }
          return data;
        })
        .then(function(data) {
          console.log(data);
          store.state.buttonFX(button, "Success!");
          return store.dispatch("login", { token: data.token });
        })
        .catch((err) => {
          console.log(err);
          loginError.value = loginErrorMessage(err);
          isRateLimited.value = err.status === 429;
          store.state.buttonFX(button, isRateLimited.value ? "Too many requests" : "Login failed");
        });
    }

    return {
      swapShowForm,
      onSubmit,
      email,
      password,
      clearFieldError,
      submitterbutton,
      showPassword,
      loginError,
      isRateLimited,
    };
  },
};
</script>
<style scoped>
button {
  margin: auto;
  cursor: pointer;
  background: none rgba(51, 92, 139);
  border: 2px solid rgba(47, 83, 125);

  text-align: center;
  margin-bottom: 0rem;
  min-height: min-content;
  max-height: 39px;
  height: 6vh;
  max-width: 162px;
  width: 100%;
  color: rgb(255, 255, 255);

  font-family: Montserrat;
  border-radius: 26px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: rgb(69, 69, 69);
  opacity: 1; /* Firefox */
}

input,
select {
  border-style: solid;
  border-width: 2px;
  border-radius: 6px;
  padding: 0.6rem 0.4rem;
  width: 100%;

  margin-bottom: 0.5rem;
  border-color: rgb(43, 94, 141, 0.7);
  display: block;
}
.password-wrapper {
  position: relative;
  margin-bottom: 0.5rem;
}

.password-wrapper input {
  padding-right: 2.5rem;
  margin-bottom: 0;
}

.toggle-password {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: rgb(43, 94, 141, 0.7);
  padding: 0.2rem;
  margin: 0;
  min-height: unset;
  max-height: unset;
  height: auto;
  max-width: unset;
  width: auto;
  border-radius: 0;
  display: flex;
  align-items: center;
}

.toggle-password:hover {
  color: rgb(43, 94, 141);
}

.toggle-password .material-symbols-outlined {
  font-size: 1.25rem;
}

.bad-border {
  border-color: red;
}

.login-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin: 0.2rem 0 0.75rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid rgba(185, 28, 28, 0.35);
  border-radius: 8px;
  background: rgba(254, 226, 226, 0.9);
  color: rgb(127, 29, 29);
  font-size: 0.78rem;
  line-height: 1.25rem;
  text-align: left;
}

.login-alert .material-symbols-outlined {
  flex: 0 0 auto;
  font-size: 1rem;
  margin-top: 0.1rem;
}

input:focus {
  outline: none;
  border-color: rgb(43, 94, 141);
  color: rgb(43, 94, 141);
}
</style>
